<template>
    <div v-if="issue_obj">
        <vs-row>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <vs-input
                    :value="issue_obj.data.id ? `Issue #${issue_obj.data.id}` : 'Auto Generated'"
                    label="* Issue ID"
                    readonly
                    class="w-full"
                />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model="issue_obj.reported_by"
                    label="Reported By"
                    placeholder="Auto Filled"
                    :multiple="false"
                    :load_initial="false"
                    :label_keys="['first_name', 'last_name']"
                    :show_id_in_label="true"
                    :endpoint="`${$store.state.apiendpoints.organisation_users}?is_active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :disabled="true"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.reported_by">
                    {{ api_errors.reported_by.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model.sync="issue_obj.data.accident_classification"
                    label="Accident Classification"
                    placeholder="Type to Search.."
                    :multiple="false"
                    :load_initial="true"
                    :label_keys="['name', ]"
                    :show_id_in_label="false"
                    :endpoint="`${$store.state.apiendpoints.data_accident_classifications}?accident_type_category=occupational&active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :disabled="mode != 'e'"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.accident_classification">
                    {{ api_errors.data.accident_classification.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <label class="vs-input--label block mb-1">Description</label>
                <vs-textarea v-model="issue_obj.data.description" :disabled="mode != 'e'" />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.description">
                    {{ api_errors.data.description.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <label class="vs-input--label block mb-1">Immediate Causes</label>
                <vs-textarea v-model="issue_obj.data.immediate_causes" :disabled="mode != 'e'" />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.immediate_causes">
                    {{ api_errors.data.immediate_causes.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <label class="vs-input--label block mb-1">Remedial Action Taken</label>
                <vs-textarea v-model="issue_obj.data.remedial_action_taken" :disabled="mode != 'e'" />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.remedial_action_taken">
                    {{ api_errors.data.remedial_action_taken.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model.sync="issue_obj.assigned_reviewers"
                    label="Select Incident Manager"
                    placeholder="Type to Search..."
                    :multiple="true"
                    :load_initial="true"
                    :label_keys="['first_name', 'last_name']"
                    :show_id_in_label="false"
                    :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :close_on_select="false"
                    :disabled="mode != 'e'"
                    :use_cache="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.assigned_reviewers">
                    {{ api_errors.assigned_reviewers.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <InputSelect 
                    :model.sync="issue_obj.data.investigation_initiated" 
                    input_class="w-full bg-white" 
                    label="Investigation Initiated"
                    :options="boolean_options"
                    :disabled="mode != 'e'"
                />
                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.investigation_initiated">
                    {{ api_errors.data.investigation_initiated.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectDate :disabled="mode != 'e'" :selectedDate.sync="issue_obj.data.date" label="Date" />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                <label class="vs-input--label block mb-1" v-if="mode == 'v'">Images</label>
                <FileSelection
                    :images.sync="issue_obj.images"
                    :filter="val => val.image_type == undefined || val.image_type == null || val.image_type == 'p'"
                    :read_only="mode != 'e'"
                />
                <small class="block text-danger mt-1" v-if="api_errors.images">
                    {{ api_errors.images.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3 px-0">
                <LocationChooser :disabled="mode != 'e'" :latitude.sync="issue_obj.data.location_latitude" :longitude.sync="issue_obj.data.location_longitude" :api_errors="{latitude: api_errors.data ? api_errors.data.location_latitude : null, longitude: api_errors.data ? api_errors.data.location_longitude : null}" />
            </vs-col>
        </vs-row>
        <vs-row class="mt-base" v-if="show_action_buttons && show_review && $store.state.is_online">
            <vs-col class="text-center">
                <vs-button @click="$emit('reject')" type="filled" color="primary" class="mx-2">
                    Reject
                </vs-button>
                <vs-button @click="$emit('approve')" type="filled" color="primary" class="mx-2">
                    Approve
                </vs-button>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import SelectDate  from '../../../components/letstream/ls-select-date/SelectDate.vue'
import LocationChooser from '../Components/LocationChooser.vue'
import FileSelection from '../Components/FileSelection.vue'

export default {
    props: {
        issue: {
            required: true,
            type: Object
        },
        api_errors: {
            required: true,
            type: Object
        },
        mode: {
            required: true,
            type: String
        },
        show_action_buttons: {
            required: true,
            type: Boolean
        },
        show_review: {
            required: true,
            type: Boolean
        },
        manager_dropdown: {
            required: true,
            type: Function
        }
    },
    components: {
        LocationChooser,
        SelectDate,
        FileSelection
    },
    data () {
        return {
            issue_obj: null,
            default_data: {
                accident_classification: null,
                description: null,
                date: new Date(Date.now()),
                immediate_causes: null,
                remedial_action_taken: null,
                investigation_initiated: null,
                location_latitude: null,
                location_longitude: null
            },

            boolean_options: [
                {label: 'Yes', value: true},
                {label: 'No', value: false}
            ]
        }
    },
    watch: {
        issue: {
            deep: true,
            handler: function (newV) {
                this._set_by_watcher = true
                this.update_issue_obj(newV)
            }
        },
        issue_obj: {
            deep: true,
            handler: function (newV) {
                if (this._set_by_watcher) {
                    this._set_by_watcher = false
                    return
                }
                this.$emit('update:issue', newV)
            }
        }
    },
    mounted() {
        this.update_issue_obj(this.issue)
    },
    methods: {
        update_issue_obj(new_data) {
            if (!new_data) this.issue_obj = null
            else {
                let issue_obj = {...new_data}
                if (!issue_obj.data)
                    issue_obj.data = this.deepclone(this.default_data)
                
                this.issue_obj = issue_obj
            }
        }
    },
}
</script>
